import { render, staticRenderFns } from "./ProPartners.vue?vue&type=template&id=412d7410&scoped=true&"
import script from "./ProPartners.vue?vue&type=script&lang=js&"
export * from "./ProPartners.vue?vue&type=script&lang=js&"
import style0 from "./ProPartners.vue?vue&type=style&index=0&id=412d7410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d7410",
  null
  
)

export default component.exports